import { useEffect, useRef } from "react";

export const usePreview = (val: unknown) => {
  const valRef = useRef(val);
  useEffect(() => {
    valRef.current = val;
  }, [val]);
  return valRef.current;
};
